// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"526":"8eb66704719e8ff4","888":"4c68ba604cd523bf"}[chunkId] + ".css";
};